import "core-js/modules/es7.object.get-own-property-descriptors";
import "core-js/modules/es6.array.iterator";
import "core-js/modules/es6.object.keys";
import "core-js/modules/es6.regexp.to-string";
import "core-js/modules/web.dom.iterable";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import { mapState } from 'vuex';
import pickBy from 'lodash/pickBy';
import { vuetifyColors } from '../../../../utils/themes';
var defaultItemsPerPage = 10;
export default {
  name: 'NiotaClassicDevicesUploadList',
  props: {
    tblHeaders: {
      type: Array,
      default: new Array()
    },
    contents: {
      type: Array,
      default: new Array()
    }
  },
  data: function data() {
    return {
      tableFooterProps: {
        itemsPerPageText: this.$i18n_t('Common.rowsPerPage'),
        itemsPerPageOptions: [defaultItemsPerPage, 20, 50]
      },
      searchItem: null,
      expanded: []
    };
  },
  computed: _objectSpread(_objectSpread({}, mapState('app', ['inpOutlined', 'inpFilled', 'image', 'color', 'UiTheme', 'permissions'])), {}, {
    filteredContent: function filteredContent() {
      var result = null;
      this.contents.forEach(function (content) {
        result = pickBy(content, function (value, key) {
          switch (key) {
            case 'applicationId':
            case 'originatorId':
            case 'originator':
            case 'deviceTypeId':
            case 'connectivityPlanId':
            case 'deviceProfileId':
            case 'properties':
            case 'otaa':
            case 'error':
            case 'valid':
            case 'add':
            case 'cType':
            case 'msg':
              return false;

            default:
              return true;
          }
        });
      });
      return result;
    }
  }),
  methods: {
    filterItems: function filterItems(item, queryText) {
      return item.title.toLocaleLowerCase().indexOf(queryText.toLocaleLowerCase()) > -1 || item.id.toString().toLocaleLowerCase().indexOf(queryText.toLocaleLowerCase()) > -1;
    },
    deleteRow: function deleteRow(index) {
      this.$emit('deleteRow', index);
    },
    deleteColumn: function deleteColumn(index) {
      this.$emit('deleteVariable', index);
    },
    getColor: function getColor(type) {
      return vuetifyColors[type];
    }
  }
};